import fsPromises from 'fs/promises';
import { z } from 'zod/v4-mini';
import { mutationProcedure } from '../trpc/common.js';
import { notifyReload } from '../utilities/notifyReload.js';
import type { ApiParams } from '../types/ApiParams.js';

export async function restartAllTasks(
  params: ApiParams<
    void,
    'bus' | 'taskRunner' | 'telemetryClient',
    'cachePath' | 'incrementSessionVersion' | 'sequence'
  >,
): Promise<void> {
  const { ctx } = params;
  const { session, bus, taskRunner, telemetryClient } = ctx;

  console.debug('ApiServer: Restarting all tasks');

  // Delete all this session's bundle results from disk, and clear the task runner's
  // in-memory records. This also sends an empty task list to the client.
  await taskRunner.clearAllResults();

  // Clear entire cloudpack cache.
  // TODO: update this to be more granular--deleting TaskRunner task results isn't enough since
  // this won't include packages that were implicitly loaded from the browser cache.
  // A better/faster way than deleting files would be if we can force the session version update
  // below to be reflected in all URLs, or use a special query param to force new bundles on reload
  // (even if a cached version with matching hash exists). An in-between solution might be to
  // delete all cached bundles referenced by the current resolve map.
  // Tracking: https://github.com/microsoft/cloudpack/issues/3003
  await fsPromises.rm(session.cachePath, { force: true, recursive: true, maxRetries: 5 });
  await fsPromises.mkdir(session.cachePath, { recursive: true });

  // Update session version.
  session.incrementSessionVersion();

  await notifyReload({ reason: 'restart-all-tasks' }, { bus, session, telemetryClient });
}

restartAllTasks.procedure = mutationProcedure(restartAllTasks, z.void(), z.void());
